module.exports = __webpack_public_path__ + "static/media/back.f2b39103.png";